import RequestViewDetailsVendorContainer from "./RequestViewDetailsVendorContainer";
import RequestViewDetailsVendorStore from "./RequestViewDetailsVendorStore";
export default RequestViewDetailsVendorStore(RequestViewDetailsVendorContainer); 